// Import our CSS
import "@/scss/app.scss";

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import Alpine from "alpinejs";
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse'

// Internal
import { menu } from "./components/menu.js";
import { scrollLink } from "./components/scrollLink.js";
import { lazyLoadVideo } from "./components/lazyLoadVideo.js";
import { globalAutoPopup } from "./components/globalAutoPopup.js";

window.addEventListener("load", () => {
  if (!document.querySelector("[data-aos]")) {
    return;
  }

  import("aos").then(({ default: AOS }) => {
    import("aos/dist/aos.css");
    AOS.init({
      once: "true",
    });
  });
});

// JS callback functions for:
// 1. Hamburger Menu toggle.
// 2. Show / Hide Mobile Menu (on hamburger button click)
menu();
scrollLink();

window.Alpine = Alpine;
Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.data("globalAutoPopup", globalAutoPopup);

const startAlpine = () => {
  Alpine.start();
};

// Get all elements with the class "child"
const childElements = document.querySelectorAll(".fire-form");

// Loop through each child element
childElements.forEach((childElement) => {
  // Add a class to the parent of each child
  const parentElement = childElement.parentNode;
  if (parentElement) {
    parentElement.classList.add("gslide-media-custom");
  }
});

document.addEventListener("DOMContentLoaded", function() {
    lazyLoadVideo();
});

/**
 * Meta Pixel: Track CompleteRegistration when Formie registration forms are successfully submitted.
 * Listens for Formie's onAfterFormieSubmit event (bubbles from form to document).
 * Formie only fires this on success (not on validation/payment errors).
 * For multi-page forms: only fire on final page (when nextPageId is falsy).
 */
document.addEventListener('onAfterFormieSubmit', function(e) {
    const detail = e.detail || {};
    // Skip if multi-page form and not on final page
    if (detail.nextPageId) return;
    // Only fire on success - no server errors
    if (detail.errors && Object.keys(detail.errors).length > 0) return;
    if (typeof window.fbq === 'function') {
        window.fbq('track', 'CompleteRegistration', { content_name: 'Event Registration' });
    }
});

window.getCookie = function(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

let qtyDigitUpdater = document.querySelectorAll('.js-cart-qty');
let qty = getCookie('cartQty');
qtyDigitUpdater.forEach(function(item) {
    item.innerHTML = qty;
    if(qty != '' && qty != 0) {
        item.classList.remove("hidden");
    } else {
        item.classList.add("hidden");
    }
});

const registerDashboardAlpineComponents = function () {
    if (document.querySelector('[id^="trigger-"]')) {
        import('flowbite').then(({ Tooltip }) => {
            window.Tooltip = Tooltip;
        });
    }

    Alpine.store('entry', {
        galleryImages: [],
        bannerImage: [],
        tribeLogo: [],
        push(id, url, field)
        {
            switch(field) {
            case "galleryImages":
                this.galleryImages.push(...[{
                    id: id,
                    url: url
                }]);
                break;
            case "bannerImage":
                this.bannerImage.push(...[{
                    id: id,
                    url: url
                }]);
                break;
            case "tribeLogo":
                this.tribeLogo.push(...[{
                    id: id,
                    url: url
                }]);
                break;
            default:
                this.galleryImages.push(...[{
                    id: id,
                    url: url
                }]);
            }

        }
    });

    Alpine.data("couponValidator", (experienceId, originalPrice, installmentsMonths = 0) => ({
        couponCode: '',
        isValidating: false,
        isApplied: false,
        message: '',
        messageType: '', // 'success' or 'error'
        discount: 0,
        finalPrice: originalPrice,
        originalPrice: originalPrice,
        discountDisplay: '',
        hasScholarship: false,
        paymentFields: null,
        submitButton: null,
        installmentsMonths: Number(installmentsMonths) || 0,
        stripeProvider: null,

        syncFormFieldRefs() {
            this.paymentFields =
                this.$el.querySelector('.fui-type-payment') ||
                this.$el.querySelector('[data-field-type="payment"]');
            this.submitButton = this.$el.querySelector('.fui-submit');
        },

        isMonthlyPayment() {
            const checked = this.$el.querySelector(
                '[data-field-handle="paymentDuration"] input[type="radio"]:checked, ' +
                '[data-field-handle="paymentDuration"] select'
            );

            if (!checked) {
                return false;
            }

            return (checked.value || '').toLowerCase() === 'monthly';
        },

        getChargeAmountCents() {
            const dollars = Number(this.finalPrice);
            const totalCents = Math.round((Number.isFinite(dollars) ? dollars : this.originalPrice) * 100);

            if (this.isMonthlyPayment() && this.installmentsMonths > 1) {
                return Math.trunc(totalCents / this.installmentsMonths);
            }

            return totalCents;
        },

        getStripeElementOptions() {
            const options = {
                amount: this.getChargeAmountCents(),
            };

            if (this.isMonthlyPayment() && this.installmentsMonths > 1) {
                // Must match PaymentIntent setup_future_usage set server-side for installments
                options.setupFutureUsage = 'off_session';
            } else {
                options.setupFutureUsage = null;
            }

            return options;
        },

        syncStripeElements() {
            if (!this.stripeProvider) {
                return;
            }

            const options = this.getStripeElementOptions();

            if (this.stripeProvider.paymentInformation) {
                Object.assign(this.stripeProvider.paymentInformation, options);
            }

            if (this.stripeProvider.elements) {
                this.stripeProvider.elements.update(options);
            }
        },

        setupStripeInstallmentSync() {
            if (this.installmentsMonths < 2) {
                return;
            }

            const bindStripeField = ($field) => {
                if (!$field || $field.dataset.installmentStripeBound === '1') {
                    return;
                }

                $field.dataset.installmentStripeBound = '1';
                $field.addEventListener('beforeInit', (e) => {
                    this.stripeProvider = e.detail.stripe;
                    const options = this.getStripeElementOptions();
                    Object.assign(e.detail.elementOptions, options);

                    if (this.stripeProvider?.paymentInformation) {
                        Object.assign(this.stripeProvider.paymentInformation, options);
                    }
                });
            };

            const paymentField =
                this.$el.querySelector('[data-field-type="payment"]') ||
                this.$el.querySelector('.fui-type-payment');
            bindStripeField(paymentField);

            // In case Formie mounts payment later (conditions), observe once
            const observer = new MutationObserver(() => {
                const field =
                    this.$el.querySelector('[data-field-type="payment"]') ||
                    this.$el.querySelector('.fui-type-payment');
                if (field) {
                    bindStripeField(field);
                }
            });
            observer.observe(this.$el, { childList: true, subtree: true });

            const paymentDurationField = this.$el.querySelector('[data-field-handle="paymentDuration"]');
            if (paymentDurationField) {
                paymentDurationField.addEventListener('change', () => {
                    this.syncStripeElements();
                });
            }
        },

        setupCouponField() {
            // Use Alpine's $nextTick to ensure DOM is ready
            this.$nextTick(() => {
                // Get payment and submit elements first
                this.syncFormFieldRefs();
                this.setupStripeInstallmentSync();

                const scholarshipField = this.$el.querySelector('[data-field-handle="scholarshipCode"]');

                if (scholarshipField) {
                    const inputWrapper =
                        scholarshipField.querySelector('.fui-input-wrapper') ||
                        scholarshipField.querySelector('.fui-input-container');
                    const input = scholarshipField.querySelector('input[name="fields[scholarshipCode]"]');

                    if (inputWrapper && input) {
                        input.addEventListener('input', (e) => {
                            this.couponCode = e.target.value;
                        });

                        // Use readonly instead of disabled so value submits with form
                        this.$watch('isApplied', (value) => {
                            if (value) {
                                input.setAttribute('readonly', 'readonly');
                                input.style.backgroundColor = '#f3f4f6'; // gray-100
                                input.style.cursor = 'not-allowed';
                            } else {
                                input.removeAttribute('readonly');
                                input.style.backgroundColor = '';
                                input.style.cursor = '';
                            }
                        });

                        // Add enter key listener using vanilla JS
                        input.addEventListener('keyup', (e) => {
                            if (e.key === 'Enter') {
                                this.validateCoupon();
                            }
                        });

                        // Create apply button
                        const applyBtn = document.createElement('button');
                        applyBtn.type = 'button';
                        applyBtn.textContent = 'Apply';
                        applyBtn.className = 'absolute right-2 top-1/2 -translate-y-1/2 bg-orange-500 hover:bg-orange-600 text-white px-3 py-1 rounded text-xs font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed';
                        applyBtn.style.display = 'inline-block';
                        applyBtn.addEventListener('click', () => this.validateCoupon());
                        inputWrapper.appendChild(applyBtn);

                        // Create remove button
                        const removeBtn = document.createElement('button');
                        removeBtn.type = 'button';
                        removeBtn.textContent = 'Remove';
                        removeBtn.className = 'absolute right-2 top-1/2 -translate-y-1/2 bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-xs font-medium transition-colors';
                        removeBtn.style.display = 'none';
                        removeBtn.addEventListener('click', () => this.removeCoupon());
                        inputWrapper.appendChild(removeBtn);

                        // Watch for state changes to toggle buttons
                        this.$watch('isApplied', (value) => {
                            if (value) {
                                applyBtn.style.display = 'none';
                                removeBtn.style.display = 'inline-block';
                            } else {
                                applyBtn.style.display = 'inline-block';
                                removeBtn.style.display = 'none';
                            }
                        });

                        // Watch for validation state to disable button and show loading
                        this.$watch('isValidating', (value) => {
                            if (value) {
                                applyBtn.disabled = true;
                                applyBtn.textContent = '...';
                            } else {
                                applyBtn.disabled = false;
                                applyBtn.textContent = 'Apply';
                            }
                        });

                        // Create message container
                        const messageDiv = document.createElement('div');
                        messageDiv.style.display = 'none'; // Initially hidden
                        messageDiv.style.marginTop = '0.5rem';
                        messageDiv.style.fontSize = '0.875rem';
                        messageDiv.style.fontWeight = '500';
                        scholarshipField.appendChild(messageDiv);

                        // Watch for message changes to update content and visibility
                        this.$watch('message', (value) => {
                            console.log('Message changed:', value, 'Type:', this.messageType);
                            messageDiv.textContent = value;
                            if (value) {
                                messageDiv.style.display = 'block';
                                // Update color based on type
                                if (this.messageType === 'success') {
                                    messageDiv.style.color = '#16a34a'; // green-600
                                } else if (this.messageType === 'error') {
                                    messageDiv.style.color = '#dc2626'; // red-600
                                }
                            } else {
                                messageDiv.style.display = 'none';
                            }
                        });

                        // Watch for messageType changes to update color
                        this.$watch('messageType', (value) => {
                            console.log('MessageType changed:', value);
                            if (value === 'success') {
                                messageDiv.style.color = '#16a34a'; // green-600
                            } else if (value === 'error') {
                                messageDiv.style.color = '#dc2626'; // red-600
                            }
                        });
                    }
                }

                // Setup scholarship radio field listener
                const scholarshipRadioField = this.$el.querySelector('[data-field-handle^="doYouHaveAScholarship"]');

                // If scholarship field doesn't exist, show payment fields and keep them visible.
                // Formie.initForms() runs ~50ms after this HTML is injected (see glightbox.js); its
                // conditional rules may hide payment first — same delayed re-show as the scholarship path.
                if (!scholarshipRadioField) {
                    this.hasScholarship = false;
                    const ensurePaymentVisible = () => {
                        this.syncFormFieldRefs();
                        this.showPaymentFields();
                    };
                    ensurePaymentVisible();
                    setTimeout(ensurePaymentVisible, 150);
                    setTimeout(ensurePaymentVisible, 400);
                    return;
                }

                if (scholarshipRadioField) {
                    const radioInputs = scholarshipRadioField.querySelectorAll('input[type="radio"]');

                    // Force show payment fields initially to override Formie backend conditions
                    // We'll hide them again based on scholarship selection
                    this.showPaymentFields();

                    radioInputs.forEach(radio => {
                        radio.addEventListener('change', (e) => {
                            const selectedValue = e.target.value;
                            console.log('Scholarship radio changed:', selectedValue);

                            if (selectedValue === 'Yes') {
                                this.hasScholarship = true;
                                // Only hide if no valid coupon is applied
                                if (!this.isApplied) {
                                    this.hidePaymentFields();
                                }
                            } else {
                                this.hasScholarship = false;
                                this.showPaymentFields();
                                // Reset coupon code when "No" is selected
                                console.log('Resetting coupon code');
                                this.removeCoupon();
                            }
                        });

                        // Check initial state after a short delay to let Formie conditions apply first
                        setTimeout(() => {
                            const checkedRadio = scholarshipRadioField.querySelector('input[type="radio"]:checked');
                            if (checkedRadio) {
                                if (checkedRadio.value === 'Yes') {
                                    this.hasScholarship = true;
                                    console.log('Initial state: Scholarship = Yes, hiding payment fields');
                                    this.hidePaymentFields();
                                } else {
                                    this.hasScholarship = false;
                                    console.log('Initial state: Scholarship = No, showing payment fields');
                                    this.showPaymentFields();
                                }
                            } else {
                                // No selection yet, show payment fields by default
                                console.log('Initial state: No scholarship selection, showing payment fields');
                                this.showPaymentFields();
                            }
                        }, 100);
                    });
                }
            });
        },

        hidePaymentFields() {
            console.log('Hiding payment fields');
            if (this.paymentFields) {
                this.paymentFields.style.display = 'none';
                // Disable payment field inputs so they don't validate or submit
                const inputs = this.paymentFields.querySelectorAll('input, select, textarea, button');
                inputs.forEach(input => {
                    input.setAttribute('data-was-required', input.required ? 'true' : 'false');
                    input.required = false;
                    input.disabled = true;
                });
            }
            if (this.submitButton) {
                this.submitButton.style.display = 'none';
            }
        },

        showPaymentFields(btnOnly = false) {
            if (btnOnly) {
                console.log('Showing payment fields (amount/submit only)');
            } else {
                console.log('Showing payment fields');
            }
            if (this.paymentFields && !btnOnly) {
                this.paymentFields.style.display = 'block';
                // Re-enable payment field inputs
                const inputs = this.paymentFields.querySelectorAll('input, select, textarea, button');
                inputs.forEach(input => {
                    if (input.getAttribute('data-was-required') === 'true') {
                        input.required = true;
                    }
                    input.disabled = false;
                });
            }

            if (this.submitButton) {
                this.submitButton.style.display = 'block';
            }
        },

        getCouponCodeValue() {
            const input = this.$el.querySelector('input[name="fields[scholarshipCode]"]');
            return (this.couponCode || input?.value || '').trim();
        },

        async validateCoupon() {
            const code = this.getCouponCodeValue();
            if (!code) {
                this.showError('Please enter a coupon code');
                return;
            }

            this.isValidating = true;
            this.message = '';

            try {
                const response = await fetch('/api/validate-coupon?' + new URLSearchParams({
                    experienceId: experienceId,
                    couponCode: code
                }), {
                    cache: 'no-store',
                    headers: {
                        'Accept': 'application/json',
                        'Cache-Control': 'no-cache'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`);
                }

                const data = await response.json();
                console.log('Validation response:', data);

                if (
                    data.success &&
                    data.couponCode &&
                    data.couponCode.toUpperCase() !== code.toUpperCase()
                ) {
                    console.log('Validation response coupon mismatch:', data.couponCode, code);
                    this.showError('Invalid coupon code');
                    return;
                }

                if (data.success) {
                    this.isApplied = true;
                    this.discount = data.discount;
                    this.finalPrice = data.finalPrice;
                    this.discountDisplay = data.discountDisplay;
                    this.showSuccess(data.message);

                    // Update the amount field in the form (this is just for display/reference)
                    // The backend will recalculate based on scholarshipCode field
                    const amountField = this.$el.querySelector('input[name="fields[amount]"]');
                    if (amountField) {
                        amountField.value = data.finalPrice;
                        const changeEvent = new Event('change');
                        amountField.dispatchEvent(changeEvent);
                        console.log('Updated amount field to discounted price:', data.finalPrice);
                    }

                    this.syncStripeElements();

                    // If scholarship was selected, show payment fields after valid coupon
                    if (this.hasScholarship) {
                        console.log('Valid coupon applied with scholarship - showing payment fields');
                        this.showPaymentFields(amountField && amountField.value == 0);
                    }
                } else {
                    console.log('Validation failed, showing error:', data.message);
                    this.showError(data.message);
                }
            } catch (error) {
                console.error('Coupon validation error:', error);
                this.showError('Failed to validate coupon code');
            } finally {
                this.isValidating = false;
            }
        },

        removeCoupon() {
            this.isApplied = false;
            this.couponCode = '';
            this.message = '';
            this.messageType = '';
            this.discount = 0;
            this.finalPrice = this.originalPrice;
            this.discountDisplay = '';

            const scholarshipInput = this.$el.querySelector('input[name="fields[scholarshipCode]"]');
            if (scholarshipInput) {
                scholarshipInput.value = '';
            }

            // Reset the amount field
            const amountField = this.$el.querySelector('input[name="fields[amount]"]');
            if (amountField) {
                amountField.value = this.originalPrice;
            }

            this.syncStripeElements();

            // If scholarship is selected, hide payment fields again
            if (this.hasScholarship) {
                console.log('Coupon removed with scholarship - hiding payment fields');
                this.hidePaymentFields();
            }
        },

        showSuccess(msg) {
            console.log('showSuccess called with:', msg);
            this.messageType = 'success';
            this.message = msg;
        },

        showError(msg) {
            console.log('showError called with:', msg);
            this.messageType = 'error';
            this.message = msg;
        },

        init() {
            // Watch for changes and clear error message when user types
            this.$watch('couponCode', (newValue, oldValue) => {
                // Only clear error if user is typing (both values exist)
                // Don't clear if we're programmatically clearing the field
                if (this.messageType === 'error' && newValue && oldValue) {
                    console.log('User is typing, clearing error message');
                    this.message = '';
                    this.messageType = '';
                }
            });
        }
    }));

    Alpine.data("alpineMuliSelect", (obj) => ({
        elementId: obj.elementId,
        options: [],
        selected: Array.isArray(obj.selected) ? obj.selected : [obj.selected],
        limit: obj.limit ?? null, // Set your desired limit here
        selectedElms: [],
        show: false,
        search: '',
        focusedOptionIndex: null,
        open() {
            this.generateOptions();

            this.show = true;
            this.focusedOptionIndex = null;

            if(this.limit == 1) {
                for (var i = 0; i < this.options.length; i++) {
                    if(this.options[i].selected) {
                        this.focusedOptionIndex = i;
                    }
                }
            }
        },
        close() {
            this.show = false;
            this.focusedOptionIndex = null;
            this.search = '';
        },
        toggle() {
            this.show = !this.show;
        },
        isOpen() {
            return this.show === true;
        },

        // Initializing component
        init() {
            this.createSelectedElements();

            // searching for the given value
            this.$watch("search", (e => {
                this.focusedOptionIndex = null;
                this.generateOptions();
            }));
        },
        // clear search field
        clear() {
            this.search = '';
        },
        // deselect selected options
        deselect() {
            setTimeout(() => {
                this.selected = [];
                this.selectedElms = [];
                Object.keys(this.options).forEach((key) => {
                    this.options[key].selected = false;
                });
            }, 100);
        },
        // select given option
        select(index, target) {
            if (this.limit === 1) {
                if (!this.options[index].selected) {
                    this.options.forEach(opt => {
                        opt.selected = false;
                    });
                    this.selected = [];
                    this.selectedElms = [];

                    // Override selection
                    this.options[index].selected = true;
                    this.options[index].element = target;

                    this.selected.push(this.options[index].value);
                    this.selectedElms = [this.options[index]];

                    this.close();
                }
            }

            else {
                if (! this.options[index].selected) {
                    if(this.limit == null || this.selected.length <= this.limit) {
                        this.options[index].selected = true;
                        this.options[index].element = target;
                        this.selected.push(this.options[index].value);
                        this.selectedElms.push(this.options[index]);

                        if (this.limit == this.selectedElms.length) {
                            this.close();
                        }
                    }
                } else {
                    this.selected.splice(this.selected.lastIndexOf(index), 1);
                    this.options[index].selected = false;
                    Object.keys(this.selectedElms).forEach((key) => {
                        if (this.selectedElms[key].value == this.options[index].value) {
                            setTimeout(() => {
                                this.selectedElms.splice(key, 1);
                            }, 10);
                        }
                    })
                }
            }

        },

        // remove from selected option
        remove(index, option) {
            this.selectedElms.splice(index, 1);
            Object.keys(this.options).forEach((key) => {
                if (this.options[key].value == option.value) {
                    this.options[key].selected = false;
                    Object.keys(this.selected).forEach((skey) => {
                        if (this.selected[skey] == option.value) {
                            this.selected.splice(skey, 1);
                        }
                    });
                }
            });
        },

        selectOption() {
            if (this.isOpen() && this.focusedOptionIndex !== null) {
                /*let focusedOption = this.options[this.focusedOptionIndex];
                console.log(focusedOption);

                focusedOption.selected = !focusedOption.selected;*/

                let optionElement = document.getElementById(this.elementId).parentElement.querySelector(`li[data-key='${this.focusedOptionIndex}']`);
                this.select(this.focusedOptionIndex, optionElement);
            }
        },

        focusPreviousOption() {
            if (this.isOpen()) {
                if (this.focusedOptionIndex === null) {
                    this.focusedOptionIndex = this.options.length - 1;
                } else if (this.focusedOptionIndex > 0) {
                    this.options[this.focusedOptionIndex].focused = false;
                    this.focusedOptionIndex--;
                }

                this.options[this.focusedOptionIndex].focused = true;

                this.$nextTick(() => {
                    let optionElement = document.getElementById(this.elementId).parentElement.querySelector(`li[data-key='${this.focusedOptionIndex}']`);
                    if (optionElement) {
                        optionElement.scrollIntoView({
                            block: 'center',
                        });
                    }
                });
            }
        },

        focusNextOption() {
            if (this.isOpen()) {
                if (this.focusedOptionIndex === null) {
                    this.focusedOptionIndex = 0;
                } else if (this.focusedOptionIndex < this.options.length - 1) {
                    this.options[this.focusedOptionIndex].focused = false;
                    this.focusedOptionIndex++;
                }

                this.options[this.focusedOptionIndex].focused = true;

                this.$nextTick(() => {
                    let optionElement = document.getElementById(this.elementId).parentElement.querySelector(`li[data-key='${this.focusedOptionIndex}']`);
                    if (optionElement) {
                        optionElement.scrollIntoView({
                            block: 'center',
                        });
                    }
                });
            }
        },

        // filter out selected elements
        selectedElements() {
            return this.options.filter(op => op.selected === true);
        },

        generateOptions() {
            this.options = [];
            let options = document.getElementById(this.elementId).options;
            let reg = new RegExp(this.search, 'gi');

            for (let i = 0; i < options.length; i++) {

                let option = {
                    value: options[i].value,
                    text: options[i].innerText,
                    search: options[i].dataset.search,
                    selected: Object.values(this.selected).includes(options[i].value)
                };

                if(this.search == null || (this.search != null && options[i].dataset.search.match(reg))) {
                    this.options.push(option);
                }
            }
        },

        createSelectedElements() {
            this.options = [];
            this.selectedElms = [];
            let options = document.getElementById(this.elementId).options;
            let reg = new RegExp(this.search, 'gi');

            for (let i = 0; i < options.length; i++) {
                if(Object.values(this.selected).includes(options[i].value)) {
                    let option = {
                        value: options[i].value,
                        text: options[i].innerText,
                        search: options[i].dataset.search,
                        selected: true
                    };

                    this.selectedElms.push(option);
                }
            }
        },
    }));

    // Start Alpine only after all Alpine.data() / Alpine.store() registrations
    // above have run. Previously startAlpine was registered on DOMContentLoaded
    // before this handler, so Alpine initialized before alpineMuliSelect existed.
    startAlpine();
};

// Wait for DOMContentLoaded so deferred body modules (e.g. tribe-map.js) run
// before Alpine.start(). app.js is in <head>, so it executes before body scripts
// when readyState is "interactive".
if (document.readyState === "complete") {
    registerDashboardAlpineComponents();
} else {
    document.addEventListener("DOMContentLoaded", registerDashboardAlpineComponents);
}